var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.125 17.6039C4.22917 15.3154 0 9.85819 0 6.7599C0 3.02787 3.09896 0 7 0C10.8646 0 14 3.02787 14 6.7599C14 9.85819 9.73438 15.3154 7.83854 17.6039C7.40104 18.132 6.5625 18.132 6.125 17.6039ZM7 9.0132C8.27604 9.0132 9.33333 8.02738 9.33333 6.7599C9.33333 5.52763 8.27604 4.5066 7 4.5066C5.6875 4.5066 4.66667 5.52763 4.66667 6.7599C4.66667 8.02738 5.6875 9.0132 7 9.0132Z",
    fill: "#F38A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalIcon);
export default __webpack_public_path__ + "static/media/local-icon.c1896f180065d56cf7aecff8f0109383.svg";
export { ForwardRef as ReactComponent };